import { gql } from '@/features/graphql/generated'

export const CategoriesQuery = gql(/* GraphQL */ `
    query Categories {
        categories {
            ...Category
            subcategories {
                ...Category
            }
        }
    }
`)
